const DEFAULT_TIME = 30;

let interval = null;

const updateTime = (timer, timeOut) => {
  const timeCounter = timer.querySelector('.js-timer-counter');
  if (timeCounter) {
    timeCounter.textContent = timeOut;
  }
};

const stopTimer = (timer, btn) => {
  if (timer) {
    timer.classList.add('hidden');
  }

  if (btn) {
    btn.classList.remove('hidden');
  }

  clearInterval(interval);
  interval = null;
};

const startTimer = (timer, btn) => {
  if (timer) {
    timer.classList.remove('hidden');

    let timeOut = timer.dataset.time || DEFAULT_TIME;
    updateTime(timer, timeOut);
    interval = setInterval(() => {
      timeOut -= 1;
      if (timeOut >= 0) {
        updateTime(timer, timeOut);
      } else {
        stopTimer(timer, btn);
      }
    }, 1000);
  }

  if (btn) {
    btn.classList.add('hidden');
  }
};

const destroyTimer = (wrapper) => {
  if (!wrapper) {
    return;
  }

  const timer = wrapper.querySelector('.js-timer');
  const repeatBtn = wrapper.querySelector('.js-repeat-btn');

  stopTimer(timer, repeatBtn);
};

const initTimer = (wrapper) => {
  if (!wrapper) {
    return;
  }

  const timer = wrapper.querySelector('.js-timer');
  const repeatBtn = wrapper.querySelector('.js-repeat-btn');

  startTimer(timer, repeatBtn);

  if (repeatBtn && !repeatBtn.classList.contains('is-initialized')) {
    repeatBtn.addEventListener('click', (evt) => {
      evt.preventDefault();
      startTimer(timer, repeatBtn);
    });
    repeatBtn.classList.add('is-initialized');
  }
};

export {initTimer, destroyTimer};
